export class Animator {
    animate({ timing, draw, duration, afterEnd, }) {
        const start = performance.now();
        requestAnimationFrame(function animationFunc(time) {
            let timeFraction = (time - start) / duration;
            if (timeFraction > 1) {
                timeFraction = 1;
            }
            const progress = timing(timeFraction);
            draw(progress);
            if (timeFraction < 1) {
                requestAnimationFrame(animationFunc);
            }
            else if (afterEnd) {
                afterEnd();
            }
        });
    }
}
